import { cn } from '@repo/lib/cn';

import type { DropzoneDragAreaProps } from '.';

export function DropzoneDragArea(imageUploadDragAreaProps: DropzoneDragAreaProps) {
  const { className, isDragging, ...props } = imageUploadDragAreaProps;
  return (
    <div
      tabIndex={0}
      className={cn('border-border-primary hover:bg-accent/80 my-6 rounded-md border border-dashed px-4 py-6 transition-colors duration-200', isDragging && 'border-border-brand', className)}
      {...props}
    />
  );
}
